<ng-template #deleteConfirm let-c="close" let-d="dismiss">
  <div class="modal-header modal-header-color">
    <h4 class="modal-title">
      {{titleText}}
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <i class="fas fa-times"></i>
    </button>
  </div>
  <div class="modal-body" [innerHTML]="textDeleteConfirm">
  </div>
  <div class="modal-footer">
  <button class="btn btn-outline-secondary" (click)="c()">
    {{cancel}}
  </button>
  <button class="btn btn-outline-danger" (click)="submit()">
    {{confirm}}
  </button>
  </div>
</ng-template>

<button *ngIf="type === 'invoice-delete'" class="btn btn-dv btn-wide" (click)="open(deleteConfirm);"
[disabled] = "disabledButton" >
  {{deleteMessage}}
</button>

<button *ngIf="type === 'normal-design'" class="btn btn-outline-danger" (click)="open(deleteConfirm);">
  {{deleteMessage}}
</button>

<i *ngIf="type === 'trash-icon'" class="fa fa-trash fa-lg light-red-color pointer"
   (click)="open(deleteConfirm)"></i>



// WEBPACK FOOTER //
// /opt/app/src/app/core/delete-modal/delete-modal.component.html